var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSwapVertLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19628)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8 11.7998V28.7998H15.6V11.7998H17.8Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0222 10.7221C15.9517 9.79251 17.4482 9.79251 18.3778 10.7221C18.3841 10.7284 18.3904 10.7348 18.3965 10.7413L24.3965 17.0413L22.8034 18.5585L16.8167 12.2725C16.7483 12.209 16.6516 12.209 16.5832 12.2725L10.5965 18.5585L9.00342 17.0413L15.0034 10.7413C15.0096 10.7348 15.0158 10.7284 15.0222 10.7221Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6 36.3999V19.3999H31.8V36.3999H29.6Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4236 37.5299C31.5338 38.5878 29.986 38.4416 29.1221 37.5776C29.1159 37.5714 29.1097 37.5651 29.1037 37.5587L23.0037 31.1587L24.5962 29.6409L30.6832 36.0273C30.7163 36.0581 30.7502 36.0703 30.7736 36.0737C30.7834 36.0626 30.7934 36.0516 30.8037 36.0409L36.9037 29.6409L38.4962 31.1587L32.4236 37.5299Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.4,
    height: 28.2,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwapVertLight);
export default __webpack_public_path__ + "static/media/icon_swap_vert_light.b05f50a5.svg";
export { ForwardRef as ReactComponent };